import { Icon } from "@/components/ui/icon";
import { useCurrentUser } from "@/hooks/use-current-user";
import type { DetailedListing } from "@/lib/types";
import { useTranslations } from "next-intl";

export type ListingGalleryPhotosOnRequestProps = {
  listing: DetailedListing;
};

export function ListingGalleryPhotosOnRequest({
  listing,
}: ListingGalleryPhotosOnRequestProps) {
  const t = useTranslations();

  const { user } = useCurrentUser();

  if (
    user &&
    (user.id === listing.ownerId || user.id === listing.sellerAgentId)
  ) {
    return null;
  }

  return (
    <div className="absolute bottom-4 right-4 flex items-center border bg-background rounded-md select-none">
      <div className="py-1.5 px-2 border-r">
        <Icon icon="Lock1Solid" />
      </div>

      <div className="py-1.5 px-2 font-medium">
        {t("saas.listing.photos.onDemand")}
      </div>
    </div>
  );
}
